import style from './visualiser.module.scss';

export default function Footer(){
    return(
        <footer
            className={style.footer}
        >
            &copy; 2022 Giulia Passoni
        </footer>
    )
}